// Generated by scripts/wizbuild.mjs.
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { PageAccessComponent } from './page.access/page.access.component';
import { PageDashboardComponent } from './page.dashboard/page.dashboard.component';
import { PageDomainsComponent } from './page.domains/page.domains.component';
import { PageImagesComponent } from './page.images/page.images.component';
import { PageMacrosComponent } from './page.macros/page.macros.component';
import { PageMacrosDetailComponent } from './page.macros.detail/page.macros.detail.component';
import { PageOperationsComponent } from './page.operations/page.operations.component';
import { PageOperationsDetailComponent } from './page.operations.detail/page.operations.detail.component';
import { PageReportsComponent } from './page.reports/page.reports.component';
import { PageSchedulesComponent } from './page.schedules/page.schedules.component';
import { PageServersComponent } from './page.servers/page.servers.component';
import { PageServersDetailComponent } from './page.servers.detail/page.servers.detail.component';
import { PageServicesComponent } from './page.services/page.services.component';
import { PageServicesDetailComponent } from './page.services.detail/page.services.detail.component';
import { PageSystemComponent } from './page.system/page.system.component';
import { PageTemplatesComponent } from './page.templates/page.templates.component';
import { PageTemplatesDetailComponent } from './page.templates.detail/page.templates.detail.component';
import { LayoutEmptyComponent } from './layout.empty/layout.empty.component';
import { LayoutSidebarComponent } from './layout.sidebar/layout.sidebar.component';

const routes: Routes = [
  { path: '', pathMatch: 'full', redirectTo: 'access' },
  {
    path: '',
    component: LayoutEmptyComponent,
    children: [
      { path: 'access', component: PageAccessComponent }
    ]
  },
  {
    path: '',
    component: LayoutSidebarComponent,
    children: [
      { path: 'dashboard', component: PageDashboardComponent },
      { path: 'domains', component: PageDomainsComponent },
      { path: 'images', component: PageImagesComponent },
      { path: 'macros', component: PageMacrosComponent },
      { path: 'macros/:id', component: PageMacrosDetailComponent },
      { path: 'operations', component: PageOperationsComponent },
      { path: 'operations/:id', component: PageOperationsDetailComponent },
      { path: 'reports', component: PageReportsComponent },
      { path: 'schedules', component: PageSchedulesComponent },
      { path: 'servers', component: PageServersComponent },
      { path: 'servers/:id', component: PageServersDetailComponent },
      { path: 'services', component: PageServicesComponent },
      { path: 'services/:id', component: PageServicesDetailComponent },
      { path: 'system', component: PageSystemComponent },
      { path: 'templates', component: PageTemplatesComponent },
      { path: 'templates/:id', component: PageTemplatesDetailComponent }
    ]
  },
  { path: '**', redirectTo: 'access' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule {}
